import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../../ui/select";

export const STATUS_OPTIONS = [
  { value: "pendiente", label: "Pendiente", className: "bg-amber-500/15 text-amber-700 border-amber-500/40" },
  { value: "contactado", label: "Contactado", className: "bg-blue-500/15 text-blue-700 border-blue-500/40" },
  { value: "ganado", label: "Ganado", className: "bg-emerald-500/15 text-emerald-700 border-emerald-500/40" },
];

export const QuoteStatusSelect = ({ quoteId, status, onChange }) => {
  const current = STATUS_OPTIONS.find((s) => s.value === status) || STATUS_OPTIONS[0];

  return (
    <Select value={status} onValueChange={(value) => onChange(quoteId, value)}>
      <SelectTrigger
        data-testid={`admin-quote-status-select-${quoteId}`}
        className={`w-36 h-8 text-xs font-medium border ${current.className}`}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {STATUS_OPTIONS.map((opt) => (
          <SelectItem key={opt.value} value={opt.value} data-testid={`admin-quote-status-option-${opt.value}`}>
            {opt.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
